import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    events: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_EVENT_SELECT_IDS (store, ids) {
      store.events.selectIds = ids
    },
    REMOVE_EVENT_SELECT_IDS (store, ids) {
      store.events.selectIds = store.events.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_EVENT_SELECT_ID (store, id) {
      store.events.selectId = id
    },
    SET_EVENT_FILTERS (store, filters) {
      store.events.filters = filters
    },
    SET_EVENT_PAGINATE (store, val) {
      store.events.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getEvents: (store, getters) => {
      return store.events.selectIds.map((id) => {
        return getters['entities/events/find'](id)
      })
    },
    getEventsFilters: (store, getters) => {
      return store.events.filters
    },
    getEventsPaginate: (store, getters) => {
      return store.events.paginate
    },
    getEvent: (store, getters) => {
      return getters['entities/events/find'](store.events.selectId) || {}
    }
  },
  actions: {
    /*
    selectEvents
    */
    selectEvents ({commit, dispatch, getters, state}, filters) {
      return dispatch('getEvents', filters)
      .then((response) => {
        commit('SET_EVENT_FILTERS', filters)
        commit('SET_EVENT_PAGINATE', response)
        commit('SET_EVENT_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectEvents
    */
    refreshSelectEvents ({commit, dispatch, getters, state}) {
      return dispatch('selectEvents', getters.getEventsFilters)
    },
    /*
    selectEvent
    */
    selectEvent ({commit, dispatch, getters, state}, id) {
      return dispatch('getEventById', id)
      .then((response) => {
        commit('SET_EVENT_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getEvents
    */
    getEvents ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/events`, {params: filters})
      .then((response) => {
        return dispatch('entities/events/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.events || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getEventById
    */
    getEventById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/events/${id}`)
      .then((response) => {
        return dispatch('entities/events/insert', {
          data: response.data
        })
      })
      .then((result) => {
        dispatch('changeEvent', result.events[0])
        return result.events[0]
      })
    },
    /*
    createEvent
    */
    createEvent ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/events`, data)
      .then((response) => {
        return dispatch('entities/events/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changeEvent', response.events[0])
        return response.events[0]
      })
    },
    /*
    updateEvent
    */
    updateEvent ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/events/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/events/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changeEvent', response.events[0])
        return response.events[0]
      })
    },
    /*
    deleteEvent
    */
    deleteEvent ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/events/${id}`)
      .then((response) => {
        commit('REMOVE_EVENT_SELECT_IDS', [id])
        dispatch('entities/events/delete', id)
        dispatch('changeEvent', {})
        return {}
      })
    },
    /*
    changeCandidate
    */
    changeEvent ({commit, dispatch, getters, state}, data) {
      if (data.candidate_id && data.candidate_id._id) {
        dispatch('getCandidateById', data.candidate_id._id)
      } else if (getters.getCandidate._id) { // on delete
        dispatch('getCandidateById', getters.getCandidate._id)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Event.js